import React from 'react';
import ReactLoader from 'react-loader';
import { BrowserRouter as Router } from 'react-router-dom';
import { connect } from 'react-redux'
import { withRouter } from 'react-router';
import queryString from 'query-string';
import TimeOut from './components/TimeOut';

//import { withCookies, Cookies } from 'react-cookie';
import Header from './layout/Header';
import Jumbotron from './layout/Jumbotron';
import Breadcrumb from './layout/Breadcrumb';
import Content from './layout/Content';
import Footer from './layout/Footer';
import LoaderIndicator from './LoaderIndicator';
import AuthenticationAPI from './api/AuthenticationAPI.js';
import { MessageAPI, PageMessage } from './components/PageMessage.jsx';
import WebAPI from './api/WebAPI.js';

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state={};
    this.setAppDetail = this.setAppDetail.bind(this);
    this.handleDeleteUserAction = this.handleDeleteUserAction.bind(this);
    this.clearMessage = this.clearMessage.bind(this);
    this.redirectToLogin = this.redirectToLogin.bind(this);
    
  }
  componentWillMount() {
    this.setAppDetail(window.location.href, this.props.location.search);
  }
  setAppDetail(href, search) {
    //now get a session or indicate authentication required
    var url = href.substring(0, href.length - search.length);
    var parsed = queryString.parse(search);
    
    var parameter = [];
    for (var key in parsed) {
       parameter[key] = parsed[key];
    }
    this.props.setAppDetail(url, parameter);
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.application.executionStep !== nextProps.application.nextStep) {
      if (nextProps.application.nextStep === 'AUTH_INIT') {
        this.props.initAuth(nextProps.application.tokenId);
      } else if (nextProps.application.nextStep === 'USER_INIT') {
        this.props.initUser();
      } else if(nextProps.application.nextStep === 'TERMS_CONDITION'){
          this.props.history.push(window.env.appcontext + '/termandcondition');
      } else if (nextProps.application.nextStep === 'APP_VIEW') {

      } else if (nextProps.application.nextStep === 'USER_LOGIN') {
        if(nextProps.application.sessionExpired){
          this.setState({ appMessage: { displayType: 'popup', popupAction:["Login"], popupActionHandler:this.handleDeleteUserAction, messageType: 'warning', messageInfo: {popuptitle: "Session Expired", message: "Current session is expired, Please login again", messageCode: 'RELOGIN_CONFIRMATION' } } });
        } else if(nextProps.application.outsideNetworkLink){
			this.setState({ appMessage: { displayType: 'popup', popupAction:["OK"], popupActionHandler:this.handleDeleteUserAction, messageType: 'warning', messageInfo: {popuptitle: "AST Network Outside Link", message: "This link is only available inside the AST network.", messageCode: 'RELOGIN_CONFIRMATION' } } });
		} else if(nextProps.application.appLoadError){
			this.setState({ appMessage: { displayType: 'popup', popupAction:["OK"], popupActionHandler:this.handleDeleteUserAction, messageType: 'warning', messageInfo: {popuptitle: "Application is down", message: "Application appears to be down, Please contact admin.", messageCode: 'RELOGIN_CONFIRMATION' } } });
		} else{
          this.redirectToLogin();
        }
      }
      if (nextProps.application.nextStep === 'APP_VIEW_ERROR') {
        this.setState({ appMessage: { displayType: 'popup', popupAction:["Login"], popupActionHandler:this.handleDeleteUserAction, messageType: 'warning', messageInfo: {popuptitle: "Session Expired", message: "Current session is expired, Please login again", messageCode: 'RELOGIN_CONFIRMATION' } } });
      }
    }
  }


  handleDeleteUserAction(action) {
    this.clearMessage();
    if (action === 'Close' || action === 'close') {
      return;
    }
    let _thisForm = this;
    if (action === 'Login') {
      this.redirectToLogin();
    }
  }
  clearMessage() {
    this.setState({ appMessage: {} });
  }
  setMessage(message) {
    this.setState(message);
  }
  redirectToLogin(){
	    var paramString = "";
	    window.location.href = window.env.LOGINAPP_URL;
  }
  render() {
    if (this.props.application.user != null) {
      return (
        <Router>
          <div id="app-content">
            <Header user={this.props.application.user} />
            <TimeOut redirectToLogin={this.redirectToLogin}/>
            <Jumbotron />
            <Breadcrumb />
            <LoaderIndicator/>
            <PageMessage message={this.state.appMessage} />
            <Content />
            <Footer />
          </div>
        </Router>
      );
    } else {
      //Anything else 
      return <div id="app-content"><center>Loading.........Please wait!</center></div>
    }
  }
}

const mapStateToProps = (state) => {
  return {
    application: state.application
  }
}

function mapDispatchToProps(dispatch) {
  return ({
    setAppDetail: (href, search, tokenIdFromURL) => {
      //can i pass token id to authstore
      dispatch({
        type: "APP_INIT",
        payload: { 'href': href, 'search': search}
      });
    },
    initAuth: (tokenIdFromURL) => {
      dispatch({
        type: "AUTH_INIT",
        payload: AuthenticationAPI.init()
      })
    },
    initUser: () => {
      dispatch({
        type: "USER_INIT",
        payload: WebAPI.getData("/session/")
      })
    }

  })
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(App))
